// Config.
import Config 	from './config/config.js';

// Misc dependencies.
import createActionTypes from '../../factories/actionTypes.js';

/**
 * <pre>
 * Goal module Action Types.
 *
 * Summary of responsibilities:
 *
 *  - defines Redux action types specific to component
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Goal
 * @namespace
 *
 * @type {Object}
 * @property {String} REGISTER_INSTANCE Dispatched during app initialisation to register N instances of the given module (eg. we might have 3 different Goals on one page).
 * @property {String} UPDATE_PROGRESS Dispatched when the current progress (eg. percentage of completion towards milestone or goal target) of the Goal requires retrieving from the server.
 * @property {String} UPDATE_STATE Dispatched when the state (eg. can the user vote again today, have we got any active milestones to take part in currently etc.) of the Goal requires updating.
 * @property {String} UPDATE_INTERVALS Dispatched when the dynamic progress polling interval needs recalculating.
 * @property {String} SHOW_CONFIRMATION Dispatched when the user has participated and we need to show a confirmation message.
 * @property {String} HIDE_CONFIRMATION Dispatched when the user clicks to close the confirmation message.
 * @property {String} SHOW_CAPTCHA Dispatched when the user attemptes to participate but there is a fraud strategy in place requiring them to first complete a Captcha.
 * @property {String} HIDE_CAPTCHA Dispatched when the user completes or aborts the Captcha
 * @property {String} SHOW_ERROR Dispatched when we need to show any type of error.
 * @property {String} HIDE_ERROR Dispatched when we need to hide an error.
 */
const ActionTypes = {
	REGISTER_INSTANCE: 	'REGISTER_INSTANCE',

	UPDATE_PROGRESS: 	'UPDATE_PROGRESS',
	UPDATE_STATE: 		'UPDATE_STATE',
	UPDATE_INTERVALS:	'UPDATE_INTERVALS',

	SHOW_CONFIRMATION: 	'SHOW_CONFIRMATION',
	HIDE_CONFIRMATION: 	'HIDE_CONFIRMATION',

	SHOW_CAPTCHA: 		'SHOW_CAPTCHA',
	HIDE_CAPTCHA: 		'HIDE_CAPTCHA',

	SHOW_ERROR: 		'SHOW_ERROR',
	HIDE_ERROR: 		'HIDE_ERROR'
};

export default createActionTypes(ActionTypes, Config.stateKey);